<template>
	<div
		class="feature-card mx-auto p-[24px] lg:p-8 lg:pb-14 flex flex-col gap-4"
		:class="transparent ? 'bg-transparent' : 'black-bg'"
	>
		<div
			class="w-20 h-20 relative bg-gradient-to-r from-blue-300 to-pink rounded-full"
		>
			<div class="w-12 h-12 left-[16px] top-[16px] absolute">
				<img
					:alt="icon"
					class="mb-4"
					:src="icon"
				/>
			</div>
		</div>
		<div class="text-white text-2xl font-medium mt-12">
			{{ title }}
		</div>
		<p class="text-slate-200 text-base">
			{{ description }}
		</p>
	</div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
	title: String,
	icon: String,
	description: String,
	transparent: Boolean
});
</script>

<style lang="scss" scoped>
@use "~/assets/utils.scss" as *;
.feature-card {
	position: relative;

	$border: 2px;
	// background: rgb(15, 20, 36);
	background: rgb(33, 40, 63);
	background-clip: padding-box;
	border: solid $border transparent;
	border-radius: 1em;

	&:before {
		content: "";
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: -1;
		margin: -$border;
		border-radius: inherit;
		background: linear-gradient(to right, $blue-300, $pink);
	}
}
</style>
